import { logistica_GUIA_PROFORMAviewModel } from "../../../ViewModels/logistica_GUIA_PROFORMAviewModel"
import Navbar from "../../NavBar/Navbar"
import SideBar from "../../NavBar/Sidebar"
import CrearGuia from "./ContentGuia"

interface childsProps{
    logout: () => void
}

const ContentGuia: React.FC<childsProps> = ({logout}) =>{
    const vm = new logistica_GUIA_PROFORMAviewModel()
    return (
       
    <div className="sidebar-noneoverflow">
        <Navbar logout={logout}/>
    
        <div className="main-container" id="container">
            <SideBar/>
            <CrearGuia vm={vm}/>
        </div>

    </div>

    )
}


export default ContentGuia